module.exports = __webpack_public_path__ + "img/Wellness.922b6080.png";